import { useQuery } from '@tanstack/react-query';
import { container } from '@infrastructure/di/container';

export const useRequestSettingsDefaults = () => {
  return useQuery({
    queryKey: ['request-settings', 'defaults'],
    queryFn: () => container.requestSettings.getDefaults(),
    staleTime: Infinity,
  });
};
